import React from "react";
import CustomChart from "../../components/customChart/customChart";
import { AnswerContext } from "../../store/answerStore";
import ReactionSummary from "./reactionSummary";

export default function TestSumDnB1({ isSubmit }) {
  const { answerC, dispatchAnswer } = AnswerContext();

  // if (arrayValidation answerC.answers[0])
  const {
    totalScore,
    averageTimeSpend,
    totalTimeSpend,

    //Position
    corPos,
    inCorPos,
    omiPos,
    commPos,
    quickTapPos,
    timeSpendPos,
    posTap,

    //sound
    corSound,
    inCorSound,
    omiSound,
    commSound,
    quickTapSound,
    timeSpendSound,
    soundTap,
  } = answerC.answers[0];

  return (
    <div className="sum-dnb">
      <ReactionSummary
        totalScore={Math.sign(totalScore) === -1 ? 0 : Math.floor(totalScore)}
        averageTimeSpend={averageTimeSpend}
        correct1={corPos}
        correct2={corSound}
        incorrect1={inCorPos}
        incorrect2={inCorSound}
        tap1={posTap}
        tap2={soundTap}
        scoreHead1="Position"
        scoreHead2={"Sound"}
        omi1={omiPos}
        omi2={omiSound}
        com1={commPos}
        com2={commSound}
        quickTap1={quickTapPos}
        quickTap2={quickTapSound}
        totalTap={posTap + soundTap}
        comingFrom="dnb"
      />
    </div>
  );
}
